export function getB2cOrigin(baseUrl: string): string {
  if (baseUrl.equalsIgnoreCase('https://hub.flokk.com')) {
    return 'https://store.flokk.com';
  }

  return baseUrl.replace('-b2b', '');
}
